<!--
/**
* @Author: wulizhou
* @Description: 宠粉俱乐部
* @Date:
**/
-->

<template>
  <div class="FanClub">
    <div class="header-wrapper"></div>


    <div class="main-wrapper">

      <div class="inner_center_1330">
        <!-- 每日签到 -->
        <div class="sign-by-day">
          <div class="title-box">
            <i class="icon_sign"/>
            签到免费领VIP
            <i class="iconfont3 icon-cz-question-fill">
              <div
                class="hover-box"
              >
                签到免费领VIP规则：<br>
                1、每日签到后，可获得对应的VIP天数奖励（普通VIP 1张/天），领取的VIP天数可累加<br>
                2、VIP兑换后立即生效，不可商用，仅供学习交流<br>
                3、周三、周五是惊喜盲盒日，签到可获得随机高额VIP天数<br>
                4、活动解释权归潮国创意所有<br>
              </div>
            </i>
          </div>

          <div class="sign-list">

            <template v-for="(item,index) in signByWeek">
              <div class="sign-item"
                   v-if="index+1 != whatDay"
                   :key="index"
              >
                <div class="sign-item-title">{{ item.time }}</div>
                <i class="icon_sign-item-gift"
                   :class="item.giftType"
                ></i>
                <div class="sign-item-gift-name"
                     :class="{ 'ON': index < whatDay }"

                >{{ item.signStatus == 1 ? '已签到' : item.gift  }}
                </div>
              </div>



              <div class="sign-item sign-item-on"
                   :class="item.giftType"
                   v-else
                   :key="index"
              >
                <i class="icon_sign-item-gift"
                   :class="item.giftType"
                ></i>
                <div class="sign-item-gift-name">{{ item.gift }}</div>
                <div class="sign-btn sign-btn-grey" v-if="currDaySignStatus == 1">已签到</div>
                <div class="sign-btn" v-else @click="signByDay(item)">点击签到</div>
              </div>


            </template>


          </div>


          <!-- 余额兑换 -->
          <div class="sign-exchange">
            VIP余额：
            <span class="txt-remain">{{ personVipSignDays }}天</span>
            <div class="exchange-btn" @click="exchangeVip">点击兑换</div>
          </div>


        </div>


        <!-- 基础任务 -->
        <div class="basic-task">

          <div class="title-box">
            <i class="icon_sign"/>
            粉丝基础任务
            <i class="iconfont3 icon-cz-question-fill">
              <div
                class="hover-box"
              >
                粉丝基础任务规则：<br>
                1、根据任务要求，去完成对应的操作即可获得VIP天数奖励（普通VIP 1张/天）<br>
                2、请留意页面左上角的时间倒计时，倒计时结束即可领取奖励<br>
                3、违规操作将取消奖励资格，情况严重将封禁账号，包括但不限于恶意注册、批量完成任务等<br>
                4、活动解释权归潮国创意所有<br>
              </div>
            </i>
          </div>

          <div class="task-list">
            <div class="task-item"
                 v-for="(item,index) in basicTask"
                 :key="index"
            >
              <i :class="item.iconClass"></i>
              <div class="task-content">
                <div class="task-name">{{ item.task_name }}</div>
                <div class="task-gift">{{ "领取" + item.reward_value + (item.reward_type == 1 ? "天VIP" : "个积分") }}</div>
              </div>


              <div class="input-box" v-if="item.task_type == 3 && item.showInput">
                <el-input type="textarea" v-model="item.input"
                          @input="onInput()"
                          resize="none"
                          placeholder="请输入内容"
                ></el-input>
                <i class="iconfont2 icon-qy-error-circle-fill"
                   @click="closeInput(item,index)"
                ></i>
                <div class="submit-btn" @click="submitTask(item, index)">提交</div>
              </div>

              <div class="task-btn BtnHover"
                   @click="doTask(item,index)"
                   v-if="item.progress == 0"
              >去做任务
              </div>

              <div class="task-btn task-btn-complete"
                   v-else
              >已完成
              </div>
            </div>
          </div>

        </div>

        <!-- VIP任务 -->
        <div class="vip-task">

          <div class="title-box">
            <i class="icon_sign"/>
            免费领取VIP任务
            <i class="iconfont3 icon-cz-question-fill">
              <div
                class="hover-box"
              >
                免费领取VIP任务规则：<br>
                1、根据任务要求，去完成对应的分享操作，并提交任务截图，等待审核完成<br>
                2、“免费领取VIP任务”审核通过之后才可以领取奖励（商用VIP 1张/天），审核周期1~3个工作日<br>
                3、截图不符合任务要求，会审核失败，请认真提交<br>
                4、活动解释权归潮国创意所有<br>
              </div>
            </i>
          </div>

          <div class="share-task-list">
            <div class="share-task-item"
                 v-for="( item,index ) in shareTask"
                 :key="index"
            >

              <div class="share-task-item-content">
                <div class="share-task-title">
                  <i class="iconfont icon-fenxiang"></i>
                  <span>{{ item.task_name }}</span>
                </div>
                <div class="share-task-content">
                  <div class="share-task-step">第一步</div>
                  <div class="share-task-btn BtnHover" @click="share(item)">点击分享
                  </div>
                  <div class="share-task-step">第二步</div>
                  <div class="share-task-upload upload-card">
                    <el-upload
                      action="/"
                      ref="upload"
                      accept="image/jpg,image/jpeg,image/png,image/gif"
                      class="avatar-uploader"
                      :show-file-list="false"
                      :on-success="(res, file) =>handleAvatarSuccess(res, file,item,index)"
                      :on-change="(file, fileList) => changeCard(file, fileList,item, index)"
                    >
                      <img :src="item.imgUrl" class="avatar">
                      <i class="el-icon-plus avatar-uploader-icon"></i>
                    </el-upload>

                    <template v-if="!item.imgUrl">
                      <i class="iconfont3 icon-cz-add-circle-fill"></i>
                      <span class="card-tips">{{ item.shareTips }}</span>
                    </template>


                    <!--
                      当前任务进度:0 可做,
                      1 已完成,当为分享任务时,为审核中,
                      2 当为分享任务时,为待领取任务,
                      3 任务当日上限
                     -->
                    <div class="upload-audit" v-if="item.progress == 1">
                      已上传 <br>
                      审核中
                    </div>
                    <div class="upload-audit upload-audit-success" v-if="item.progress == 2">
                      审核通过
                    </div>
                    <div class="upload-audit upload-audit-fail" v-if="item.progress == 4 && !item.imgUrl">
                      审核未通过
                      <div class="overflow-one remark">{{ item.remark }}</div>

                      <div class="upload-bar">
                        <i class="iconfont3 icon-cz-add-circle-fill"></i>重新上传
                      </div>
                    </div>

                    <div class="submit-btn BtnHover"
                         v-if="item.progress != 2 && item.progress != 1  && item.fileListByCard && item.fileListByCard.length"
                         @click="submitTaskByUploadImg(item)">
                      提 <br>交
                    </div>
                  </div>
                  <div class="share-task-step">第三步</div>
                  <div class="share-task-receive-vip">
                    <div class="btn-1"
                         :class="[
                           { 'btn-shrink': item.progress == 3},
                           { 'btn-success': item.progress == 2 },
                         ]"
                         @click="receiveVip(item)"

                    >{{ "领取商用VIP1天" }}
                    </div>
                    <div class="btn-1 want" v-if="item.progress == 3"
                         @click="wantDoTask(item)"
                    >我也想要
                    </div>
                  </div>

                </div>
              </div>

            </div>
          </div>

        </div>

      </div>
      <!-- 邀请奖励 -->
      <div class="invitation-reward">
        <div class="inner_center_1330">

          <div class="title-box">
            邀请返利活动
            <i class="iconfont3 icon-cz-question-fill">
              <div class="hover-box">
                邀请返利活动规则：<br>
                1、复制链接分享给好友，好友通过链接去充值，每充值1元，您可获得1个积分（链接有效期48小时，请及时更新）<br>
                2、积分不具有法币交易支付等功能和地位，仅可兑换潮国VIP会员<br>
                3、兑换VIP成功后立即生效，请及时使用VIP权益<br>
                4、参加邀请返利的用户，如果被邀请人退款，您的积分会被收回，已兑换的VIP会作废<br>
                5、活动解释权归潮国创意所有<br>
              </div>
            </i>
          </div>

          <!--  邀请码 -->
          <div class="invite-code-panel">

            <div class="invite-btn BtnHover"
                 @click="createInviteCode"
            >生成专属邀请码
            </div>
            <div class="panel-title">邀请新用户成为VIP</div>

            <div class="invite-info">
              <i class="icon_invite"></i>
              <span>共邀请：</span>
              <div class="invite-num">{{ invite_total }}</div>
              <span>人</span>
              <span class="txt-remark">（*邀请人每充值1元获得1积分）</span>
            </div>
          </div>

          <div class="coin-exchange">

            <div class="title-box">
              <i class="icon_sign"/>
             积分余额 ：<span class="coin-rain">{{ coinNum }}</span>
            </div>

            <div class="coin-exchange-content">
              <div class="coin-exchange-title">积分兑换</div>
              <div class="coin-exchange-list">
                <div class="coin-exchange-item"
                     :class="item.type"
                     v-for="(item,index) in exchangeList"
                     :key="index"
                >
                  <div class="coin-exchange-name">{{ item.name }}</div>
                  <div class="coin-exchange-usable-range">{{ item.type | disposeType }}</div>
                  <div class="exchange-btn" @click="exchangeVipByCoin(item)">立即兑换</div>
                  <div class="coin-exchange-num">
                    <span class="txt-coin-exchange-num">{{ item.exchangeNum }}</span>
                    <span class="txt-coin">/ 积分</span>
                  </div>
                </div>
              </div>
              <div class="coin-exchange-more">更多兑换商品，敬请期待···</div>
            </div>
          </div>


        </div>
      </div>
    </div>

    <!--  组件 -->
    <no-ssr>
      <!-- 邀请分享弹框 -->
      <inviteModal ref="inviteModal"/>


      <!--  用户画像  -->
      <SurveyUserDialog
        ref="SurveyUserDialog"
      />

      <!-- 兑换成功弹框 -->
      <ExchangeSuccessModal ref="ExchangeSuccessModal"
                            :headline="exchangeModal.headline"
                            :sub-head="exchangeModal.subHead"
      />

    </no-ssr>
  </div>
</template>

<script>

/* 引入公共方法和常量 */
import * as fnCommon from '@/fn/_fn';
import * as CON_COMMON from '@/constant/_constant';

/* 插件 */
const dayjs = require('dayjs');
import upyun from "upyun";
import _ from 'lodash'

/* 引入组件 */
import inviteModal from "@/components/_components/fans/club/inviteModal";
import SurveyUserDialog from '@/pages/survey/user';
// import BindIphone from "@/components/common/bind-iphone";
import ExchangeSuccessModal from "@/components/_components/fans/club/ExchangeSuccessModal"


/* 引入VUEX */
import {mapState} from "vuex";

/* 引入API */
import {
  bindInviteByFansClub,
  completeTask, completeTaskByFanClub,
  exchangeVip,
  getActInfo,
  getSignListByWeek,
  getTaskList,
  signByWeek, wantDoTask
} from "@/api/fans/club";
import {fnLogin} from "@/fn";
import {setUserBindIphoneAloneModalStatus} from "@/components/_Privately/User/UserBindIphoneAloneModal/module";

/* 周签到 */
const SIGN_WEEK_GIFT = [
  {
    time: "周一",
    gift: "1天VIP",
    giftType: "vip",
    num: 1
  },
  {
    time: "周二",
    gift: "0.3天VIP",
    giftType: "vip",
    num: 0.3
  },
  {
    time: "周三",
    gift: "惊喜盲盒",
    giftType: "gif",
    num: 0.5
  },
  {
    time: "周四",
    gift: "0.2天VIP",
    giftType: "vip",
    num: 0.2
  },
  {
    time: "周五",
    gift: "惊喜盲盒",
    giftType: "gif",
    num: 0.7
  },
  {
    time: "周六",
    gift: "0.6天VIP",
    giftType: "vip",
    num: 0.6
  },
  {
    time: "周日",
    gift: "0.5天VIP",
    giftType: "vip",
    num: 0.5
  },
]

/* 基础任务 */
const BASIC_TASK = [
  {
    iconClass: "icon_view",
    label: "浏览并订阅一个专题",
    getVip: "领取0.2个VIP",
    isCompleteTask: false
  },
  {
    iconClass: "icon_like",
    label: "随意收藏一张潮国素材",
    getVip: "领取0.2个VIP",
    isCompleteTask: false
  },
  {
    iconClass: "icon_write",
    label: "填写一句对潮国创意的初印象",
    getVip: "领取0.2个VIP",
    isCompleteTask: false
  },
  {
    iconClass: "icon_search",
    label: "浏览列表页活动",
    getVip: "领取0.2个VIP",
    isCompleteTask: false
  },
]

/* 兑换套餐 */
const EXCHANGE_LIST = [
  {
    id: 1,
    name: "普通VIP-3个月",
    type: "person",
    exchangeNum: 390,
  },
  {
    id: 2,
    name: "普通VIP-1年",
    type: "person",
    exchangeNum: 990,
  },
  {
    id: 3,
    name: "普通VIP-终身",
    type: "person",
    exchangeNum: 2590,
  },
  {
    id: 4,
    name: "商用VIP-1个月",
    type: "business",
    exchangeNum: 490,
  },
  {
    id: 5,
    name: "商用VIP-3个月",
    type: "business",
    exchangeNum: 690,
  },
  {
    id: 6,
    name: "商用VIP-1年",
    type: "business",
    exchangeNum: 1990,
  },
  {
    id: 7,
    name: "标准版-1年",
    type: "company",
    exchangeNum: 3990,
  },
  {
    id: 8,
    name: "高级版-1年",
    type: "company",
    exchangeNum: 9900,
  },
  {
    id: 9,
    name: "升级版-1年",
    type: "company",
    exchangeNum: 26000,
  },
]

/* 分享任务 */
const SHARE_TASK = [
  {
    id: 1,
    label: "分享到微信朋友圈",
    pic: "",
    isSubmit: false
  },
  {
    id: 2,
    label: "分享到小红书",
    pic: "",
    isSubmit: false
  },
  {
    id: 3,
    label: "分享到微博",
    pic: "",
    isSubmit: false
  },
  {
    id: 4,
    label: "分享到相关社群",
    pic: "",
    isSubmit: false
  },
]

export default {
  name: "FanClub"

  , layout: "header-nav"

  , components: {
    inviteModal,
    SurveyUserDialog,
    // BindIphone,
    ExchangeSuccessModal
  }

  , props: {}

  , watch: {
    basicTask: {
      handler(n, o) {
        if (n) {
          n.forEach(item => {
            if (item.task_type == 1) {
              item.iconClass = "icon_like"
            } else if (item.task_type == 2) {
              item.iconClass = "icon_view"
            } else if (item.task_type == 3) {
              item.iconClass = "icon_write"
            } else if (item.task_type == 4) {
              item.iconClass = "icon_search"
            } else {
              item.iconClass = "icon_search"
            }
          })
        }
      },
      deep: true
    },

    /* 登录更新详情收藏 */
    isLogin(n, o) {
      if (n == true) {
        this.bindInviter()
      }
    },
  }

  , computed: {
    ...mapState('user', [
      'avatar',
      'isLogin',
      'name',
      'uniq_id',
      'vipIsPerson',
      'vipIsPersonData',
      'vipIsBusiness',
      'vipIsBusinessData',
      'companyVipState'
    ])
  }

  , mounted() {
    this.whatDay = this.getWhatDay();

    console.log('--this.whatDay---')
    console.log(this.whatDay)
    this.init();
  }

  , data() {
    return {
      signByWeek: SIGN_WEEK_GIFT
      , whatDay: 0                    // 当日周几
      , basicTask: BASIC_TASK
      , exchangeList: EXCHANGE_LIST
      , shareTask: []
      , currDaySignStatus: false      // 当日签到状态
      , personVipSignDays: 0
      , coinNum: 0
      , invite_total: 0                // 邀请人数
      , exchangeModal: {
        headline: ""
        , subHead: ""
      }
    }
  }

  , methods: {
    init() {
      this.getTaskList();
      this.bindInviter()
      this.getActInfo();
      this.getSignListByWeek();
    }

    , showInviteModal() {
      this.$refs.inviteModal.isShowModal = true
    }
    /* 获取当天为周几 */
    , getWhatDay() {
      const weekday = dayjs().day();

      if (weekday === 0){
        return 7
      }else{
        return weekday;
      }
    }

    /* 周签到进度 */
    , getSignListByWeek() {
      getSignListByWeek().then(res => {

        let {status, data} = res.data;
        if (status == 200) {
          if (!this._.isEmpty(data)) {
            for (const key in data) {

              console.log(key)
              let index = parseInt(key) - 1;
              // let index = parseInt(key);
              let signByWeekItem = this.signByWeek[index];
              signByWeekItem.signStatus = data[key];
              this.$set(this.signByWeek, index, signByWeekItem);

              /* 更新每日签到状态 */
              // this.currDaySignStatus = data[this.whatDay + 1]
              this.currDaySignStatus = data[this.whatDay]
            }
          }
          console.log(this.signByWeek)


        }
      })
    }

    /* 当日签到 */
    , signByDay(item) {

      if (fnLogin.checkLogin()){
        signByWeek().then(res => {
          let {status, data, message} = res.data;
          if (status == 200) {

            this.exchangeModal = {
              headline: "签到成功",
              subHead: `恭喜领取${item.num}天VIP`
            }
            this.$refs.ExchangeSuccessModal.isShow = true;


            this.$myNotify.success(message);
            this.currDaySignStatus = 1;
            this.getActInfo();
          } else {
            this.$myNotify.error(message);
          }
        })
      }else{
        fnLogin.loginIntercept(false)
      }

    }

    /* 获取活动信息 */
    , getActInfo() {
      getActInfo().then(res => {
        console.log(res)
        let {status, data} = res.data;
        if (status == 200) {
          if (this._.isObject(data) && !this._.isEmpty(data)) {
            if ("personal_vip" in data) {
              this.personVipSignDays = data['personal_vip'];
            }
            if ("coin" in data) {
              this.coinNum = data['coin'];
            }
            if ("invite_total" in data) {
              this.invite_total = data['invite_total'];
            }
          }
        }
      })
    }

    , filterArray(array) {
      const unfinished = array.filter(item => item.progress == 0);
      const completed = array.filter(item => item.progress == 1);

      const result = unfinished.slice(0, 4);
      const remaining = 4 - result.length;

      if (remaining > 0) {
        const additional = completed.slice(0, remaining);
        result.push(...additional);
      }

      return result;
    }

    /* 获取任务列表 */
    , getTaskList() {
      getTaskList().then(res => {
        let {status, message, data} = res.data;
        if (status == 200) {

          let {basic = [], share = []} = data;
          if (fnLogin.checkLogin()) {
            basic = basic.length > 4 ? this.filterArray(basic) : basic;
            basic.forEach(item => {
              if (item.task_type == 3) {
                item.showInput = false;
                item.input = ""
              }
            })
          } else {
            basic.forEach(item => item.progress = 0)
            basic = basic.length > 4 ? this.filterArray(basic) : basic;
          }

          this.basicTask = basic
          console.log(this.basicTask)

          /* 分享任务文案设置 */
          share.forEach(item => {
            if (item.task_name.indexOf("微信朋友圈") > -1) {
              item.shareTips = "点击上传朋友圈截图"
            } else if (item.task_name.indexOf("小红书") > -1) {
              item.shareTips = "点击上传小红书分享截图"
            } else if (item.task_name.indexOf("微博") > -1) {
              item.shareTips = "点击上传微博分享截图"
            } else if (item.task_name.indexOf("社群") > -1) {
              item.shareTips = "点击上传分享社群截图"
            } else if (item.task_name.indexOf("豆瓣") > -1) {
              item.shareTips = "点击上传分享豆瓣截图"
            } else {
              item.shareTips = "点击上传分享截图"
            }
          })

          this.shareTask = share;
        }
      })
    }

    /* 兑换VIP 日签到 */
    , exchangeVip() {

      if(fnLogin.checkLogin()){
        let parseIntDays = parseInt(this.personVipSignDays);
        if (parseIntDays == 0) {
          this.$myNotify.show("不足一天无法兑换噢！！！")
          return false
        }

        exchangeVip({
          mode: "sign"
        }).then(res => {
          console.log(res)

          let {status, message, data} = res.data;
          if (status == 200) {

            this.$myNotify.success("兑换成功", () => {
              /* 更新用户信息 */
              this.$store.dispatch('user/getUserInfo')
              this.$store.dispatch('user/GetUserVipInfo')
              this.getSignListByWeek();
              this.getActInfo();
            })
          } else {
            this.$myNotify.error(message);
          }
        })
      }else{
        fnLogin.loginIntercept(false)
      }

    }

    , onInput() {
      this.$forceUpdate();
    }

    /* 做任务 */
    , doTask(item, index) {

      if (fnLogin.checkLogin()){
        const {link, task_type, id} = item;
        let path = `${link}?task_type=${task_type}&t_id=${id}`;

        if (task_type == 1 || task_type == 2) {

          fnCommon.fnBasic.navigationTo(path);


        } else if (task_type == 3) {
          /*item.showInput = true;
          item.input = '';
          // this.$set(item, "showInput", true)
          this.$set(this.basicTask, index, item)*/
          // this.$refs.BindIphone.actIsShow = true
          setUserBindIphoneAloneModalStatus(this.$store,true)
          this.$router.push({
            query: {
              task_type,
              t_id:id,
            }
          })

        } else if (task_type == 6) {
          this.$refs.SurveyUserDialog.actIsShow = true
          this.$router.push({
            query: {
              task_type,
              t_id:id,
            }
          })
        }
      }else{
        fnLogin.loginIntercept(false)
      }


    }

    /* 清空并关闭 */
    , closeInput(item, index) {
      item.showInput = false;
      item.input = '';
      this.$set(this.basicTask, index, item)

    }


    , submitTask(item, index) {
      item.input = item.input.replace(/\s/g, '');
      if (item.input == '') {
        this.$myNotify.error("请输入内容")
      } else {
        completeTaskByFanClub({id: item.id}).then(res => {
          let {status, data, message} = res.data;
          if (status == 200) {
            this.$myNotify.success("任务完成", () => {
              item.showInput = false;
              item.input = '';
              this.getTaskList();
            })
          } else {
            this.$myNotify.success(message)

          }
        })
      }

    }

    /* 使用积分兑换 */
    , exchangeVipByCoin(item) {
      if (fnLogin.checkLogin()){
        let {exchangeNum} = item;
        if (this.coinNum < exchangeNum) {
          this.$myNotify.show("数量不足，兑换失败");
          return false;
        }

        exchangeVip({
          mode: "coin",
          serialNo: item.id
        }).then(res => {
          let {status, message, data} = res.data;
          if (status == 200) {

            this.exchangeModal = {
              headline: "兑换成功",
              subHead: `恭喜获得${item.name}`
            }
            this.$refs.ExchangeSuccessModal.isShow = true;

            /* 更新用户信息 */
            this.$store.dispatch('user/getUserInfo')
            this.$store.dispatch('user/GetUserVipInfo')
            this.getSignListByWeek();
            this.getActInfo();

          } else {
            this.$myNotify.error(message);
          }
        })
      }else{
        fnLogin.loginIntercept(false)
      }
    }

    , bindInviter() {
      if (this.$route.query.i && fnLogin.checkLogin()) {
        bindInviteByFansClub({
          inviter: this.$route.query.i,
          invitee: this.uniq_id
        }).then(res => {
          console.log(res)

          let {status, message, data} = res.data
          if (status == 200) {
            this.$router.push({
              query: {}
            })
          } else {
            this.$router.push({
              query: {}
            })
          }

        })
      }
    }


    /* 分享 */
    , share(item) {

      if (fnLogin.checkLogin()){
        /* 简单判断当前任务数量是否满额 */

        /* 当前任务进度:0 可做, 1 已完成,当为分享任务时,为审核中,
        2 当为分享任务时,为待领取任务,
        3 任务当日上限 */
        if (item.progress == 3) {
          this.$myNotify.show("任务数量不足，下次再来")
          return false;
        }

        if (item.task_name.indexOf("微博") > -1) {
          let shareUrl = fnCommon.fnBasic.getChaopxFullLink(CON_COMMON.CON_BASIC.FANS_CLUB);
          shareUrl = shareUrl + `?i=${this.uniq_id}`;
          let shareTitle = "潮国创意宠粉特别活动，通过我的专属链接充值成功后获得等额积分。现在免费送VIP，我已经领到了，你也快来领取！"
          // let shareCover = "https://static.588ku.com/chaotu/_chaotu/fan-club/invite%40bg2.png";
          let shareCover = "https://static.588ku.com/chaotu/_chaotu/fan-club/weibo_share.png";
          fnCommon.fnBasic.shareByWeibo(shareUrl, shareTitle, shareCover)

        } else {
          this.$refs.inviteModal.isShowModal = true;
        }
      }else{
        fnLogin.loginIntercept(false)
      }




    }

    /* 邀请 */
    , createInviteCode() {
      if(fnLogin.checkLogin()){
        this.$refs.inviteModal.isShowModal = true;
      }else{
        fnLogin.loginIntercept(false)
      }
    }

    /*,beforeUpload(file,item){
      console.log({item})
      if (item.progress == 3) {
        this.$myNotify.show("任务数量不足，下次再来")
        return false;
      }
    }*/

    , handleAvatarSuccess(res, file, item, index) {
      item.imgUrl = URL.createObjectURL(file.raw);
      this.$set(item, 'imgUrl', URL.createObjectURL(file.raw))
      this.$set(this.shareTask, index, item);

    }

    , changeCard(file, fileList, item, index) {

      //获取上传文件大小
      let imgSize = Number(file.size / 1024 / 1024);

      if (imgSize > 50) {
        this.$myNotify.error("文件大小不能超过50MB，请重新上传。")

        item.imgUrl = ""
        this.$set(this.shareTask, index, item);
        return false;
      }

      item.fileListByCard = fileList;
      item.imgUrl = URL.createObjectURL(file.raw)
      // this.$set(item, 'imgUrl', URL.createObjectURL(file.raw))

      this.$set(this.shareTask, index, item);

      let _newFileList = this.submitUpload(item.fileListByCard, item)
    }


    , submitUpload: _.debounce(function (fileList) {

      console.log('--submitUpload--')

      const bucketName = 'chaopx-pic'
      const service = new upyun.Bucket(bucketName, "qianku", "HCkj58BKu@2017");

      function _b64_hmac_sha1(k, d, _p, _z) {
        // heavily optimized and compressed version of http://pajhome.org.uk/crypt/md5/sha1.js
        // _p = b64pad, _z = character size; not used here but I left them available just in case
        if (!_p) {
          _p = '=';
        }
        if (!_z) {
          _z = 8;
        }

        function _f(t, b, c, d) {
          if (t < 20) {
            return (b & c) | ((~b) & d);
          }
          if (t < 40) {
            return b ^ c ^ d;
          }
          if (t < 60) {
            return (b & c) | (b & d) | (c & d);
          }
          return b ^ c ^ d;
        }

        function _k(t) {
          return (t < 20) ? 1518500249 : (t < 40) ? 1859775393 : (t < 60) ? -1894007588 : -899497514;
        }

        function _s(x, y) {
          var l = (x & 0xFFFF) + (y & 0xFFFF), m = (x >> 16) + (y >> 16) + (l >> 16);
          return (m << 16) | (l & 0xFFFF);
        }

        function _r(n, c) {
          return (n << c) | (n >>> (32 - c));
        }

        function _c(x, l) {
          x[l >> 5] |= 0x80 << (24 - l % 32);
          x[((l + 64 >> 9) << 4) + 15] = l;
          var w = [80], a = 1732584193, b = -271733879, c = -1732584194, d = 271733878, e = -1009589776;
          for (var i = 0; i < x.length; i += 16) {
            var o = a, p = b, q = c, r = d, s = e;
            for (var j = 0; j < 80; j++) {
              if (j < 16) {
                w[j] = x[i + j];
              } else {
                w[j] = _r(w[j - 3] ^ w[j - 8] ^ w[j - 14] ^ w[j - 16], 1);
              }
              var t = _s(_s(_r(a, 5), _f(j, b, c, d)), _s(_s(e, w[j]), _k(j)));
              e = d;
              d = c;
              c = _r(b, 30);
              b = a;
              a = t;
            }
            a = _s(a, o);
            b = _s(b, p);
            c = _s(c, q);
            d = _s(d, r);
            e = _s(e, s);
          }
          return [a, b, c, d, e];
        }

        function _b(s) {
          var b = [], m = (1 << _z) - 1;
          for (var i = 0; i < s.length * _z; i += _z) {
            b[i >> 5] |= (s.charCodeAt(i / 8) & m) << (32 - _z - i % 32);
          }
          return b;
        }

        function _h(k, d) {
          var b = _b(k);
          if (b.length > 16) {
            b = _c(b, k.length * _z);
          }
          var p = [16], o = [16];
          for (var i = 0; i < 16; i++) {
            p[i] = b[i] ^ 0x36363636;
            o[i] = b[i] ^ 0x5C5C5C5C;
          }
          var h = _c(p.concat(_b(d)), 512 + d.length * _z);
          return _c(o.concat(h), 512 + 160);
        }

        function _n(b) {
          var t = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", s = '';
          for (var i = 0; i < b.length * 4; i += 3) {
            var r = (((b[i >> 2] >> 8 * (3 - i % 4)) & 0xFF) << 16) | (((b[i + 1 >> 2] >> 8 * (3 - (i + 1) % 4)) & 0xFF) << 8) | ((b[i + 2 >> 2] >> 8 * (3 - (i + 2) % 4)) & 0xFF);
            for (var j = 0; j < 4; j++) {
              if (i * 8 + j * 6 > b.length * 32) {
                s += _p;
              } else {
                s += t.charAt((r >> 6 * (3 - j)) & 0x3F);
              }
            }
          }
          return s;
        }

        function _x(k, d) {
          return _n(_h(k, d));
        }

        return _x(k, d);
      }

      function getUpyunUploadHeader(service, method, path) {
        path = '/' + service.serviceName + path;
        var date = new Date().toGMTString();
        var data = [method, path, date];
        var sign = _b64_hmac_sha1(service.password, data.join('&'));
        sign = 'UPYUN ' + service.operatorName + ':' + sign;
        return {
          'Authorization': sign,
          'X-Date': date
        };

      }

      function add0(m) {
        return m < 10 ? '0' + m : m;
      }

      function timestamp() {
        var time = new Date();
        var y = time.getFullYear();
        var m = time.getMonth() + 1;
        var d = time.getDate();
        var h = time.getHours();
        var mm = time.getMinutes();
        var s = time.getSeconds();
        return y + add0(m) + add0(d) + add0(h) + add0(mm) + add0(s);
      }

      const client = new upyun.Client(service, getUpyunUploadHeader)

      for (let i = 0; i < fileList.length; i++) {

        let item = fileList[i];

        if (!item.isUpload) {

          /* 设置文件名 */
          let time = new Date();
          let y = time.getFullYear();
          let m = time.getMonth() + 1;
          let d = time.getDate();


          item._time = `${y}/${m}/${d}/` + timestamp() + Math.ceil(Math.random() * 10000);

          if (item.raw && item.raw.type) {
            item._picName = item._time + '.' + item.raw.type.slice((item.raw.type.indexOf('/') + 1));
          }


          client.putFile(`/fans_club_upload/${item._picName}`, item.raw, {
            'Content-Type': item.raw.type,
          }).then(res => {
            console.log(res)
            console.log(res.header)
            if (res === true || res.width > 0) {
              item.LinkUrl = `https://pic.chaopx.com/fans_club_upload/${item._picName}`;
              item.url = `https://pic.chaopx.com/fans_club_upload/${item._picName}`;
              item.status = 'success'
              item.isUpload = true
            }
          }).catch(err => {
            console.log(err)
          })
        }

      }

      return fileList;

    }, 1000)

    , delUrlIp(link) {
      return '/' + link.split('/').slice(3).join('/');
    }

    , submitTaskByUploadImg(item) {

      if (item.progress == 3) {
        this.$myNotify.show("任务数量不足，下次再来")
        return false;
      }

      // console.log(Array.isArray(item.fileListByCard))
      // console.log(item.fileListByCard.length)

      if (item.fileListByCard && Array.isArray(item.fileListByCard) && item.fileListByCard.length) {

        let data = {
          id: item.id,
          content: this.delUrlIp(item.fileListByCard[0].LinkUrl)
        }

        completeTaskByFanClub(data).then(res => {
          console.log(res)

          let {status, message, data} = res.data;
          if (status == 200) {

            this.$myNotify.success("上传成功", () => {
              this.getTaskList();
            })
          } else {
            this.$myNotify.error(message)
          }
        })
      } else {
        this.$myNotify.show("请先上传截图")
      }


    }

    , receiveVip(item) {

      if (item.progress == 2) {
        exchangeVip({
          mode: "share",
          serialNo: item.id
        }).then(res => {
          let {status, message, data} = res.data;
          if (status == 200) {
            this.$myNotify.success(message, () => {
              /* 更新用户信息 */
              this.$store.dispatch('user/getUserInfo')
              this.$store.dispatch('user/GetUserVipInfo')
              this.getSignListByWeek();
              this.getActInfo();
              this.getTaskList();
            })
          } else {
            this.$myNotify.error(message);
          }
        })
      }

    }

    , wantDoTask(item) {

      wantDoTask({id: item.id}).then(res => {
        let {status, message, data} = res.data;
        if (status == 200) {
          this.$myNotify.success("您的需求我们已经收到了~");
        } else {
          this.$myNotify.show(message);
        }
      })
    }
  }


  , filters: {
    disposeType(val) {

      if (val == "person") {
        return "个人学习交流";
      } else if (val == "business") {
        return "个人商用授权";
      } else {
        return "企业商用";
      }

    }
  }

}
</script>

<style lang="scss" scoped>

.inner_center_1330 {
  width: 1330px !important;
  //width: 1368px !important;
  margin: 0 auto;
}


/* 公共样式 */
.title-box {
  font-size: 26px;
  font-weight: bold;
  color: #252626;
  line-height: 24px;
  letter-spacing: 2px;
  padding: 22px 0 0 39px;
  position: relative;

  .icon_sign {
    @include BgImage(72px, 72px, "_chaotu/fan-club/icon_sign.png");
    margin-right: 11px;
  }

  .icon-cz-question-fill {
    font-size: 16px;
    margin-left: 3px;
    position: relative;
    cursor: pointer;

    &:hover {
      color: #939393;

      .hover-box {
        display: block;
      }
    }

    &:after {
      content: '';
      display: inline-block;
      padding: 10px;
      @include Position(1, 5, 50%, 50%);
      transform: translate(-50%, -50%);
    }


    .hover-box {
      //min-width: 198px;
      //height: 60px;
      background: #424866;
      border-radius: 4px;
      @include Position(1, 5, 24px, 50%);
      transform: translateY(-50%);
      font-size: 12px;
      color: #FFFFFF;
      line-height: 16px;
      padding: 6px 8px;
      box-sizing: border-box;
      display: none;
      z-index: 99;
      width: 300px;

      &:after {
        display: inline-block;
        content: '';
        width: 8px;
        height: 8px;
        background: #424866;
        @include Position(1, 5, -4px, 50%);
        transform: translateY(-50%) rotate(135deg);
      }

      &:before {
        display: inline-block;
        content: '';
        width: 15px;
        height: 100%;
        @include Position(1, 4, -15px, 0);
        //background-color: pink;
      }
    }

    .hover-box2 {
      //width: 180px;
    }
  }
}

.BtnHover {
  cursor: pointer;

  &:hover {
    background: rgba(255, 236, 175, 1) !important;
  }
}

.header-wrapper {
  @include BgImage(100%, 553px, "_chaotu/fan-club/header@bg2.jpg", 1);
}

.main-wrapper {

  position: relative;
  //top: -173px;
  margin-top: -173px;

  /* 每日签到 */
  .sign-by-day {
    //@include BgImage(1330px, 345px, "_chaotu/fan-club/signByDay%40bg.png", 1);
    //@include BgImage(1368px, 383px, "_chaotu/fan-club/signByDay%40bg.png", 1);
    position: relative;
    //top: -172px;
    box-sizing: border-box;

    width: 1330px;
    height: 345px;
    //background: pink;
    margin-bottom: 105px;

    &:before {
      content: "";
      display: inline-block;
      @include BgImage(1368px, 383px, "_chaotu/fan-club/signByDay%40bg.png", 1);
      @include Position(1, 5, 50%, 50%);
      transform: translate(-50%, -50%);
    }

    .title-box {
      font-size: 26px;
      font-weight: bold;
      color: #252626;
      line-height: 24px;
      letter-spacing: 2px;
      padding: 12px 0 0 40px;

      .icon_sign {
        @include BgImage(72px, 72px, "_chaotu/fan-club/icon_sign.png");
        margin-right: 11px;
      }

      .icon-cz-question-fill {
        font-size: 16px;
        margin-left: 3px;
        position: relative;
        cursor: pointer;

        &:hover {
          color: #939393;

          .hover-box {
            display: block;
          }
        }

        &:after {
          content: '';
          display: inline-block;
          padding: 10px;
          @include Position(1, 5, 50%, 50%);
          transform: translate(-50%, -50%);
        }


        .hover-box {
          min-width: 198px;
          //height: 60px;
          background: #424866;
          border-radius: 4px;
          @include Position(1, 5, 24px, 50%);
          transform: translateY(-50%);
          font-size: 12px;
          color: #FFFFFF;
          line-height: 16px;
          padding: 6px 8px;
          box-sizing: border-box;
          display: none;

          &:after {
            display: inline-block;
            content: '';
            width: 8px;
            height: 8px;
            background: #424866;
            @include Position(1, 5, -4px, 50%);
            transform: translateY(-50%) rotate(135deg);
          }

          &:before {
            display: inline-block;
            content: '';
            width: 15px;
            height: 100%;
            @include Position(1, 4, -15px, 0);
            //background-color: pink;
          }
        }

        .hover-box2 {
          width: 180px;
        }
      }
    }


    .sign-list {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 34px;
      box-sizing: border-box;
      //@include Position(1, 4, 0, 64px);
      margin-top: 47px;

      .sign-item {
        width: 144px;
        height: 160px;
        background: #FFFBE5;
        border-radius: 20px;
        border: 3px solid #FCF3CA;
        display: flex;
        flex-direction: column;
        align-items: center;
        position: relative;
        cursor: pointer;

        .sign-item-title {
          height: 20px;
          font-size: 18px;
          font-weight: bold;
          color: #FF6A45;
          line-height: 20px;
          letter-spacing: 1px;
          margin: 11px 0 0px;

        }

        .icon_sign-item-gift {

          &.vip {
            @include BgImage(60px, 60px, "_chaotu/fan-club/icon_gift%40vip.png");
            margin-top: 14px;
          }

          &.gif {
            @include BgImage(59px, 66px, "_chaotu/fan-club/icon_gift%40gift.png");
            margin-top: 8px;
          }
        }

        .sign-item-gift-name {
          width: 144px;
          height: 43px;
          background: #FFD85F;
          //@include Position(1,4,0,0);
          position: absolute;
          left: 0;
          right: 3px;
          bottom: 0;
          border-radius: 0 0 16px 16px;
          font-size: 18px;
          font-weight: bold;
          color: #252626;
          line-height: 20px;
          letter-spacing: 1px;
          display: flex;
          align-items: center;
          justify-content: center;

          &.ON {
            background: #f5f6fa;
          }
        }
      }

      .sign-item-on {
        width: 144px;
        height: 173px;
        background: linear-gradient(180deg, #D188FD 0%, #6F6BFE 100%);
        border-radius: 20px;
        border: 3px solid #FFFFFF;
        position: relative;

        &.gif {
          .icon_sign-item-gift {
            width: 84px !important;
            height: 93px !important;
            top: -40px;
          }
        }

        .icon_sign-item-gift {
          width: 84px !important;
          height: 84px !important;
          @include Position(1, 5, 50%, -27px);
          transform: translateX(-50%);
        }

        .sign-item-gift-name {
          height: 20px;
          font-size: 20px;
          font-weight: bold;
          color: #FFFFFF;
          line-height: 20px;
          letter-spacing: 2px;
          text-shadow: 0px 2px 4px #766DFF;
          position: absolute;
          top: 76px;
          background: transparent;
        }

        .sign-btn {
          @include Position(1, 4, 50%, 20px);
          transform: translateX(-50%);
          width: 114px;
          height: 37px;
          background: #FFD85F;
          box-shadow: inset 0px 1px 3px 0px #FFFFFF;
          border-radius: 19px;
          text-align: center;
          line-height: 37px;
          font-size: 16px;
          font-weight: bold;
          color: #252626;
          letter-spacing: 1px;

          &:hover {
            background: rgba(255, 236, 175, 1);
          }

          &.sign-btn-grey {
            background: rgba(245, 246, 250, 1);
          }


        }
      }
    }

    .sign-exchange {
      font-size: 20px;
      color: #FFFFFF;
      line-height: 24px;
      letter-spacing: 1px;
      display: flex;
      align-items: center;
      @include Position(1, 2, 59px, 13px);

      .txt-remain {
        font-weight: bold;
      }

      .exchange-btn {
        width: 128px;
        height: 39px;
        background: #FFD85F;
        box-shadow: inset 0px 1px 3px 0px #FFFFFF;
        border-radius: 20px;
        font-size: 16px;
        font-weight: bold;
        color: #252626;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-left: 20px;
        cursor: pointer;

        &:hover {
          background: rgba(255, 236, 175, 1);
        }
      }
    }
  }

  /* 基础任务 */
  .basic-task {
    width: 1330px;
    height: 683px;
    margin-bottom: 100px;
    position: relative;

    &:before {
      content: "";
      display: inline-block;
      @include BgImage(1368px, 745px, "_chaotu/fan-club/basic-task@bg.png");
      @include Position(1, 5, 50%, 50%);
      transform: translate(-50%, -50%);
    }

    .title-box {
      padding: 17px 0 0 33px;

      .icon_sign {
        @include BgImage(80px, 80px, "_chaotu/fan-club/icon_gift.png");
      }
    }

    .task-list {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-top: 20px;

      .task-item {
        width: 1250px;
        height: 109px;
        background: #FFFFFF;
        box-shadow: 0px 2px 16px 0px rgba(213, 221, 236, 0.39);
        border-radius: 15px;
        margin-bottom: 30px;
        display: flex;
        align-items: center;
        padding: 0 56px 0 30px;
        box-sizing: border-box;
        position: relative;


        .input-box {
          @include Position(1, 2, 56px, 50%);
          transform: translateY(-50%);
          background: #FFFFFF;
          z-index: 30;

          /deep/ .el-textarea {

            .el-textarea__inner {
              width: 572px;
              height: 79px;
              line-height: 20px;
              border-radius: 8px;
              //border: 1px solid #6969FF;
              padding: 10px 40px 10px 15px;
              box-sizing: border-box;
            }
          }

          .icon-qy-error-circle-fill {
            font-size: 18px;
            color: #ACAFBF;
            @include Position(1, 2, 10px, 10px);
            cursor: pointer;
          }

          .submit-btn {
            width: 65px;
            height: 23px;
            background: #6969FF;
            border-radius: 8px 0px 8px 0px;
            font-size: 12px;
            color: #FFFFFF;
            line-height: 24px;
            letter-spacing: 1px;
            text-align: center;
            @include Position(1, 3, 0, 0);
            cursor: pointer;

            &:hover {
              background: rgba(180, 180, 255, 1);
            }
          }
        }

        > i {
          margin-right: 29px;
        }

        .task-content {
          .task-name {
            height: 20px;
            font-size: 20px;
            color: #252626;
            line-height: 20px;
            margin-bottom: 15px;
          }

          .task-gift {
            height: 14px;
            font-size: 16px;
            color: #FF6A45;
            line-height: 14px;
            letter-spacing: 1px;
          }
        }

        .task-btn {
          width: 148px;
          height: 45px;
          background: #FFD85F;
          box-shadow: inset 0px 1px 3px 0px #FFFFFF;
          border-radius: 23px;
          font-size: 16px;
          font-weight: bold;
          color: #252626;
          letter-spacing: 1px;
          line-height: 45px;
          text-align: center;
          @include Position(1, 2, 56px, 50%);
          transform: translateY(-50%);
          cursor: pointer;


          &.task-btn-complete {
            background: rgba(245, 246, 250, 1);
          }

        }

        &:last-child {
          margin-bottom: 0;
        }


        .icon_view {
          @include BgImage(60px, 60px, "_chaotu/fan-club/icon_view.png")
        }

        .icon_like {
          @include BgImage(60px, 60px, "_chaotu/fan-club/icon_like.png")

        }

        .icon_write {
          @include BgImage(60px, 60px, "_chaotu/fan-club/icon_write.png")
        }

        .icon_search {
          @include BgImage(60px, 60px, "_chaotu/fan-club/icon_search.png")
        }
      }
    }
  }

  /* VIP 任务 */
  .vip-task {
    width: 1330px;
    height: 598px;
    position: relative;

    &:before {
      content: "";
      display: inline-block;
      @include BgImage(1368px, 636px, "_chaotu/fan-club/vipTask@bg.png");
      @include Position(1, 5, 50%, 50%);
      transform: translate(-50%, -50%);
    }

    .title-box {
      padding: 4px 0 0 30px;

      .icon_sign {
        @include BgImage(85px, 85px, "_chaotu/fan-club/icon_vip.png");
      }
    }

    .share-task-list {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 34px;

      .share-task-item {
        position: relative;
        width: 297px;
        height: 405px;
        margin-right: 20px;

        &:last-child {
          margin-right: 0;
        }

        &:before {
          content: "";
          display: inline-block;
          @include BgImage(329px, 441px, "_chaotu/fan-club/icon_share@bg2.png?v=2");
          @include Position(1, 5, 50%, 50%);
          transform: translate(-50%, -50%);
        }

        .share-task-item-content {
          position: relative;
          z-index: 5;
          top: -9px;
          left: 0;

          .share-task-title {
            font-size: 16px;
            font-weight: bold;
            color: #FFFFFF;
            line-height: 20px;
            padding-left: 20px;
            margin-bottom: 30px;

            .icon-fenxiang {
              margin-right: 3px;
            }
          }

          .share-task-content {
            padding-left: 44px;

            .share-task-step {
              font-size: 14px;
              font-weight: bold;
              color: #000001;
              line-height: 20px;
              margin-bottom: 15px;
            }

            .share-task-btn {
              display: inline-block;
              width: 208px;
              height: 45px;
              background: #FFD85F;
              box-shadow: inset 0px 1px 3px 0px #FFFFFF;
              border-radius: 23px;
              font-size: 16px;
              font-weight: bold;
              color: #252626;
              line-height: 45px;
              text-align: center;
              letter-spacing: 1px;
              margin-bottom: 24px;
            }

            .share-task-upload {
              width: 180px;
              height: 79px;
              background: #FFFFFF;
              border-radius: 14px;
              border: 2px dotted #A0A3B2;
              margin-bottom: 25px;
              box-sizing: border-box;
            }

            .share-task-receive-vip {

              display: flex;
              align-items: center;

              .btn-1 {
                width: 208px;
                height: 45px;
                background: #A0A3B2;
                border-radius: 23px;
                font-size: 16px;
                font-weight: bold;
                color: #FFFFFF;
                line-height: 45px;
                text-align: center;
                letter-spacing: 1px;
                cursor: pointer;

                &.btn-shrink {
                  width: 142px;
                }

                &.btn-success {
                  background: #5A66FE;

                  &:hover {
                    background: #7878FF;
                  }
                }


                &.want {
                  width: 88px;
                  height: 45px;
                  background: #5A66FE;
                  box-shadow: inset 0px 1px 3px 0px #FFFFFF;
                  border-radius: 23px;
                  font-size: 14px;
                  font-weight: bold;
                  color: #FFFFFF;
                  line-height: 45px;
                  text-align: center;
                  letter-spacing: 1px;
                  flex-shrink: 0;
                  margin-left: 10px;

                  &:hover {
                    background: #7878FF;
                  }
                }
              }


            }
          }
        }
      }
    }
  }


  .invitation-reward {
    margin-top: 100px;
    @include BgImage(100%, 1540px, "_chaotu/fan-club/invitation-reward@bg.png", 1);

    .title-box {
      padding: 93px 0 40px 0;
    }


    .invite-code-panel {
      width: 1330px;
      height: 225px;
      background: linear-gradient(270deg, #CD91FF 0%, #6D6AFF 100%);
      border-radius: 30px;
      padding: 54px 48px 0;
      box-sizing: border-box;
      position: relative;


      .invite-btn {
        width: 185px;
        height: 60px;
        background: #FFD85F;
        box-shadow: inset 0 1px 3px 0 #FFFFFF;
        border-radius: 30px;
        border: 2px solid #FFFFFF;
        @include Position(1, 2, 50px, 36px);
        font-size: 20px;
        font-weight: bold;
        color: #252626;
        letter-spacing: 1px;
        line-height: 60px;
        text-align: center;

        &:hover {
          background: rgba(255, 236, 175, 1);
        }
      }

      .panel-title {
        font-size: 30px;
        font-weight: bold;
        color: #FFFFFF;
        line-height: 24px;
        letter-spacing: 2px;
        border-bottom: 1px dotted rgba(255, 255, 255, 1);
        padding-bottom: 40px;
        margin-bottom: 36px;
      }

      .invite-info {
        display: flex;
        align-items: center;
        font-size: 0;
        position: relative;


        .icon_invite {
          @include BgImage(26px, 26px, "_chaotu/fan-club/icon_invite.png");
          margin-right: 6px;
        }

        span {
          font-size: 16px;
          font-weight: bold;
          color: #FFFFFF;
          line-height: 24px;
          letter-spacing: 1px;
        }

        .invite-num {
          font-size: 20px;
          font-weight: bold;
          color: #FF2740;
          line-height: 35px;
          letter-spacing: 1px;

          height: 35px;
          background: #FFFFFF;
          box-shadow: inset 0px 2px 4px 0px rgba(139, 118, 255, 0.5);
          border-radius: 10px;
          padding: 0 17px;
          margin: 0 10px 0 17px;

        }

        .txt-remark {
          font-size: 14px;
          color: #FFFFFF;
          line-height: 14px;
          letter-spacing: 1px;
          font-weight: normal;
          margin-left: 10px;
        }
      }


    }


    .coin-exchange {
      position: relative;
      width: 1330px;
      height: 990px;
      margin-top: 70px;

      &:before {
        content: "";
        display: inline-block;
        @include BgImage(1368px, 1028px, "_chaotu/fan-club/coin-exchange@bg.png");
        @include Position(1, 5, 50%, 50%);
        transform: translate(-50%, -50%);
      }

      .title-box {
        padding: 26px 0 0 52px;

        .icon_sign {
          @include BgImage(50px, 50px, "_chaotu/fan-club/icon_chao-coin.png");
        }

        .coin-rain {
          color: rgba(255, 39, 64, 1);
        }
      }

      .coin-exchange-content {
        position: relative;
        z-index: 5;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        .coin-exchange-title {
          height: 42px;
          font-size: 32px;
          font-weight: bold;
          color: #2D2B33;
          line-height: 42px;
          letter-spacing: 4px;
          margin: 45px 0 54px;
          position: relative;

          &:after {
            content: "Chao Coin";
            display: inline-block;
            font-size: 40px;
            font-weight: bold;
            color: rgba(112, 107, 255, 0.08);
            line-height: 40px;
            letter-spacing: 5px;
            @include Position(1, 5, 50%, 50%);
            transform: translate(-50%, -50%);
            white-space: nowrap;
          }
        }

        .coin-exchange-list {
          display: flex;
          flex-wrap: wrap;
          align-items: center;
          justify-content: center;

          .coin-exchange-item {
            width: 378px;
            height: 164px;
            background: #35D0BA;
            border-radius: 14px;
            margin: 0 58px 50px 0;
            color: #FFFFFF;
            padding: 24px 0 20px 30px;
            box-sizing: border-box;
            position: relative;


            &:nth-child(3n) {
              margin-right: 0;
            }

            .coin-exchange-name {
              font-size: 20px;
              font-weight: bold;
              line-height: 26px;
              letter-spacing: 1px;
            }

            .coin-exchange-usable-range {
              //width: 92px;
              display: inline-block;
              padding: 0 10px;
              height: 22px;
              border-radius: 13px;
              border: 1px solid #FFFFFF;
              font-size: 12px;
              color: #FFFFFF;
              line-height: 20px;
              box-sizing: border-box;
              margin: 6px 0 32px;

            }

            .exchange-btn {
              width: 110px;
              height: 34px;
              background: #FFFFFF;
              border-radius: 27px;
              line-height: 34px;
              text-align: center;
              cursor: pointer;
              font-weight: bold;

              &:hover {
                background: rgba(255, 255, 255, 0.90);
              }
            }

            .coin-exchange-num {
              @include Position(1, 2, 30px, 30px);
              color: #FFFFFF;
              font-weight: bold;

              .txt-coin-exchange-num {
                height: 36px;
                font-size: 36px;
                line-height: 36px;
              }

              .txt-coin {
                height: 16px;
                font-size: 12px;
                line-height: 16px;
              }
            }


            &.person {
              @include BgImage(378px, 164px, "_chaotu/fan-club/person%40bg.png");

              .exchange-btn {
                color: rgba(53, 208, 186, 1);
              }
            }


            &.business {
              @include BgImage(378px, 164px, "_chaotu/fan-club/business%40bg.png");

              .exchange-btn {
                color: rgba(105, 105, 255, 1);
              }
            }


            &.company {
              color: rgba(255, 225, 152, 1);
              @include BgImage(378px, 164px, "_chaotu/fan-club/company%40bg.png");

              .exchange-btn {
                color: rgba(35, 62, 144, 1);
              }

              .coin-exchange-usable-range {
                color: rgba(255, 225, 152, 1);
                border-color: rgba(255, 225, 152, 1);
              }

              .coin-exchange-num {
                color: rgba(255, 225, 152, 1);
              }

            }
          }
        }

        .coin-exchange-more {
          width: 378px;
          height: 70px;
          background: linear-gradient(270deg, #CD91FF 0%, #6D6AFF 100%);
          border-radius: 42px;
          font-size: 20px;
          color: #FFFFFF;
          line-height: 70px;
          text-align: center;
          cursor: pointer;

          &:hover {
            background: linear-gradient(90deg, #CD91FF 0%, #6D6AFF 100%);
          }
        }
      }
    }
  }

}


.upload-card {
  width: 246px;
  height: 150px;
  border-radius: 6px;
  @include BgImage(246px, 150px, '_chaotu/creator/card%40bg.png');
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  width: 180px;
  height: 79px;
  background: #FFFFFF;
  border-radius: 14px;
  border: 2px dotted #A0A3B2;
  margin-bottom: 25px;
  position: relative;


  .icon-cz-add-circle-fill {
    font-size: 24px;
    margin-bottom: 4px;
    color: #A0A3B2;
  }

  .card-tips {
    font-size: 12px;
    color: #A0A3B2;
    line-height: 12px;
  }

  .submit-btn {
    width: 50px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    height: 79px;
    background: #FFD85F;
    //box-shadow: inset 0px 1px 3px 0px #FFFFFF;
    border-radius: 12px;
    font-size: 16px;
    font-weight: bold;
    color: #252626;
    text-align: center;
    letter-spacing: 1px;
    margin-bottom: 24px;
    @include Position(1, 2, -64px, 50%);
    transform: translateY(-50%);
    overflow: hidden;


  }

  /deep/ .avatar-uploader {
    width: 180px;
    height: 79px;
    position: absolute;
    //opacity: 0;

    .avatar {
      display: inline-block;
      height: 79px;
      @include Position(1, 5, 50%, 0);
      transform: translateX(-50%);

    }

    .el-icon-plus {
      @include Position(1, 5, 0, 0);
      width: 180px;
      height: 79px;
      opacity: 0;
    }
  }

  .upload-audit {
    width: 180px;
    height: 79px;
    border-radius: 14px;
    background: rgba(245, 246, 250, 1);
    @include Position(1, 5, -2px, -2px);
    font-size: 14px;
    color: #2D2B33;
    line-height: 18px;
    display: flex;
    align-items: center;
    justify-content: center;

    &.upload-audit-success {
      background: rgba(245, 252, 251, 1);
      color: rgba(53, 208, 186, 1);
    }

    &.upload-audit-fail {
      background: rgba(254, 246, 246, 1);
      color: rgba(238, 82, 83, 1);
      display: inline-block;
      padding-top: 11px;
      text-align: center;
      box-sizing: border-box;
      pointer-events: none;

      .remark{
        width: 148px;
        text-align: center;
        margin: 0 auto;
      }

      .upload-bar {
        width: 100%;
        height: 26px;
        background: rgba(66, 72, 102, 0.65);
        border-radius: 1px 1px 8px 8px;
        font-size: 12px;
        color: #FFFFFF;
        @include Position(1, 4, 0, 0);
        display: flex;
        align-items: center;
        justify-content: center;

        .icon-cz-add-circle-fill {
          margin-right: 5px;
          font-size: 14px;
          color: #FFFFFF;
          margin-bottom: 0;

        }
      }
    }
  }


}

</style>
